import { useTranslation } from "react-i18next";
import { ProductUpsellCard } from "~/components/products/pdp/ProductUpsellCard";
import { SectionTitle } from "~/components/ui/section-title";
import type { ProductCrossSellContent } from "~/data/products/types";

interface CrossSellSectionProps {
  content: ProductCrossSellContent;
}

export function CrossSellSection({ content }: CrossSellSectionProps) {
  const { t } = useTranslation("products");

  return (
    <section className="bg-white py-8 md:py-15">
      <div className="wrap flex flex-col items-center gap-6 md:gap-10">
        <SectionTitle className="text-text-heading max-w-[281px] text-center md:max-w-none">
          {t(content.headline)}
        </SectionTitle>
        {/* Below md: compact cards in a scrollable, centered row (Figma's mobile variant) —
            contained within .wrap's own gutter rather than bleeding full-width, since the cards
            only overflow on the narrowest phones. md and up: the tablet/desktop row. */}
        <div className="flex w-full [scrollbar-width:none] justify-center gap-4 overflow-x-auto pb-1 [-ms-overflow-style:none] md:gap-6 md:overflow-visible md:pb-0 [&::-webkit-scrollbar]:hidden">
          {content.items.map((item) => (
            <ProductUpsellCard
              key={item.productCode}
              name={t(item.name)}
              description={t(item.description)}
              image={item.image}
              mobileImage={item.mobileImage}
              imageAlt={t(item.imageAlt)}
              productCode={item.productCode}
              href={item.href}
              ctaLabel={t(item.ctaLabel)}
              ariaLabel={t(item.ariaLabel)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
